import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ImageWithLazyLoading = props => {
  return /*#__PURE__*/_jsx("img", {
    style: {
      objectFit: 'contain'
    },
    loading: "lazy",
    src: props.src,
    height: props.height,
    width: props.width,
    "data-id": props.dataId
  });
};